<template>
	<Page>
		<template #header>Transfer</template>

		<template v-if="balanceStore.assetAmounts && transferWalletAssetAmount">
			<div class="field">
				<SelectAssetInputAmount v-model="transferWalletAssetAmount" :assetAmounts="balanceStore.assetAmounts" />
			</div>

			<div class="field">
				<BaseInput
					v-model="v$.recipient.$model"
					placeholder="Address"
					:error="v$.recipient.$errors.length !== 0"
				/>
				<div v-if="v$.recipient.$errors.length !== 0" class="error">{{ v$.recipient.$errors[0].$message }}</div>
			</div>
		</template>

		<template #footer>
			<ButtonMain :disabled="v$.$errors.length > 0" @click="send">Send</ButtonMain>
		</template>
	</Page>
</template>

<script setup lang="ts">
import { useBalanceStore } from '@/stores/useBalanceStore';
import { computed, reactive, watch } from 'vue';
import SelectAssetInputAmount from '@/components/SelectAssetInputAmount.vue';
import Page from '@/components/ui/Page.vue';
import { useWalletStore } from '@/stores/useWalletStore';
import { type SignerTransferTx } from '@waves/signer';
import ButtonMain from '@/components/ui/BaseButton.vue';
import { useSignTransactionsStore } from '@/stores/useSignTransactionsStore';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { router } from '@/router';
import { useRoute } from 'vue-router';
import { assetIdFromString } from '@/utils';
import { ref } from 'vue';
import { AssetAmount } from '@/libs/asset-amount';
import { Asset, WAVES } from '@/libs/asset';
import BaseInput from '@/components/ui/BaseInput.vue';

const balanceStore = useBalanceStore();
const walletStore = useWalletStore();
const route = useRoute();

const { sign } = useSignTransactionsStore();

const transferWalletAssetAmount = ref(new AssetAmount(new Asset(WAVES), 0));

const tx = ref<SignerTransferTx>({
	type: 4,
	amount: 0,
	assetId: typeof route.query.assetId === 'string' ? assetIdFromString(route.query.assetId) : null,
	recipient: ''
});

watch(transferWalletAssetAmount, (assetAmount) => {
	tx.value.assetId = assetAmount.asset.assetId;
	tx.value.amount = Number(assetAmount.amount);
});

watch(
	() => route.query.assetId,
	(newAssetId) => {
		transferWalletAssetAmount.value.asset.assetId =
			typeof newAssetId === 'string' ? assetIdFromString(newAssetId) : null;
	}
);

const send = () => {
	sign(tx.value, true).finally(() => router.replace('/'));
};

const addressValidator = () => {
	return /^3P[0-9a-zA-Z]{33}$/.test(tx.value.recipient);
};

const rules = {
	recipient: {
		required,
		addressValidation: {
			$validator: addressValidator,
			$message: 'Incorrect address'
		}
	}
};

const v$ = useVuelidate(rules, tx);

v$.value.$validate();
</script>
